import React from 'react';
import BodyText from '../Typography/BodyText/BodyText';
import Div from '../Element/Div/Div';
import Flex from '../Flex/Flex';
import Gutter from '../Gutter/Gutter';
import SmallText from '../Typography/SmallText/SmallText';
import styles from './Switch.module.scss';
import { CreateProps } from '../../types/utils/CreateProps';

type SwitchProps = CreateProps<
  {
    /** If the Switch is on or off */
    isOn: boolean;
    /** Label of the Switch */
    label: string;
    /** Additional description for the Switch */
    description?: string;
    /** Additional description for the Switch */
    onChange: (value: boolean) => void;
  },
  typeof Div,
  | 'borderRadius'
  | 'backgroundColor'
  | 'color'
  | 'hoverColor'
  | 'backgroundHoverColor'
  | 'fontWeight'
>;

const Switch: React.FunctionComponent<SwitchProps> = ({
  className,
  isOn,
  label,
  description,
  onChange,
  ...props
}) => {
  const stateClassName = isOn ? styles.switch__on : styles.switch__off;

  return (
    <Div className={[styles.switch, stateClassName, className]} {...props}>
      <label className={styles.switch_label}>
        <Flex centeredVertically>
          <input
            className={styles.switch_hiddenCheckbox}
            type="checkbox"
            checked={isOn}
            onChange={() => onChange(!isOn)}
          />

          <Div
            className={styles.switch_track}
            tabIndex={0}
            hideOverflow
            backgroundColor={isOn ? 'purple500' : 'gray400'}
            borderRadius={{ size: 'rounded' }}
            onKeyPress={(e) => {
              e.key === 'Enter' && onChange(!isOn);
            }}
          >
            <Div
              className={styles.switch_handle}
              borderRadius={{ size: 'rounded' }}
              backgroundColor="white"
            />
          </Div>

          <Gutter size="sm" />

          <div>
            <BodyText tagName="span" color="black" margin={false} block>
              {label}
            </BodyText>
            {description && (
              <SmallText color="gray400" margin={false} block>
                {description}
              </SmallText>
            )}
          </div>
        </Flex>
      </label>
    </Div>
  );
};

export default Switch;
